<template>
  <div class="setting-info-body">
    <div>
      <div class="setting-info-content">
        <div class="bind-title">
          <strong>绑定手机</strong>
          <p>
            <a-icon type="info-circle" theme="filled" />
            绑定手机后可用于接收与场景开放平台相关的邮件，也可作为账号登录和找回密码。
          </p>
        </div>
        <div class="bind-info" v-if="userInfo.phone">
          <p>您已绑定手机号码：{{ userInfo.phone }}</p>
        </div>
        <div class="bind-info" v-else-if="!editPhone">
          <p>您当前还未绑定手机号码，建议您</p>
          <a-button class="btn-white" @click="editPhone = !editPhone"
            >绑定手机</a-button
          >
        </div>
        <div class="bind-from" v-else>
          <div>
            <span>手机号：</span>
            <a-input
              v-model="mobileForm.mobile"
              placeholder="请填写新手机号码"
              style="width: 400px"
            />
          </div>
          <div>
            <span>验证码：</span>
            <div>
              <a-input
                v-model="mobileForm.verifyCode"
                placeholder="请填写验证码"
                style="width: 288px"
              />
              <a-button class="btn-white" @click="sendMobile"
                >发送验证码</a-button
              >
            </div>
          </div>
          <div>
            <span></span>
            <a-button class="btn-green" @click="bindMobile">确认绑定</a-button>
          </div>
        </div>
      </div>
      <div class="setting-info-content">
        <div class="bind-title">
          <strong>绑定邮箱</strong>
          <p>
            <a-icon type="info-circle" theme="filled" />
            绑定邮箱后可用于接收与场景开放平台相关的邮件，也可作为账号登录和找回密码。
          </p>
        </div>
        <div class="bind-info" v-if="userInfo.email">
          <p>您已绑定邮箱：{{ userInfo.email }}</p>
          <!-- <a-button class="btn-white" @click="editPhone = !editPhone">绑定手机</a-button> -->
        </div>
        <div class="bind-info" v-else-if="!editMail">
          <p>您当前还未绑定邮箱，为保护您账号，建议您</p>
          <a-button class="btn-white" @click="editMail = !editMail"
            >立即绑定</a-button
          >
        </div>
        <div class="bind-from" v-else>
          <div>
            <span>邮 箱：</span>
            <a-input
              v-model="emailForm.email"
              placeholder="请填写绑定邮箱"
              style="width: 400px"
            />
          </div>
          <div>
            <span>验证码：</span>
            <div>
              <a-input
                v-model="emailForm.code"
                placeholder="请填写验证码"
                style="width: 288px"
              />
              <a-button class="btn-white" @click="sendEmail"
                >发送验证码</a-button
              >
            </div>
          </div>
          <div>
            <span></span>
            <a-button class="btn-green" @click="bindEmail">确认绑定</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bindingMailbox, bindingMobile } from "@/api/login/account";
import { registerSendregistercode, registerSmsCode } from "@/api/login";

export default {
  data() {
    return {
      editPhone: false,
      editMail: false,
      mobileForm: {
        mobile: "",
        verifyCode: "",
      },
      emailForm: {
        email: "",
        code: "",
      },
    };
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    sendMobile() {
      const { mobileForm } = this;
      const { mobile } = mobileForm;
      if (!mobile) {
        this.$message.warn("请输入手机号码");
        return;
      }
      registerSmsCode({ mobile, captchaType: "register" }).then(() => {
        this.$message.success("发送成功!");
      });
    },
    bindMobile() {
      const { mobileForm } = this;
      if (!mobileForm.mobile) {
        this.$message.warn("请输入手机号码");
        return;
      }
      if (!mobileForm.verifyCode) {
        this.$message.warn("请输入验证码");
        return;
      }
      bindingMobile(mobileForm)
        .then(() => {
          this.$store.dispatch("GetInfo");
        })
        .catch((e) => {
          this.$message.warn(e.msg);
        });
    },
    sendEmail() {
      const { emailForm } = this;
      const { email } = emailForm;
      if (!email) {
        this.$message.warn("请输入邮箱");
        return;
      }
      registerSendregistercode({ email }).then(() => {
        this.$message.success("发送成功!");
      });
    },
    bindEmail() {
      const { emailForm } = this;
      if (!emailForm.email) {
        this.$message.warn("请输入邮箱");
        return;
      }
      if (!emailForm.code) {
        this.$message.warn("请输入验证码");
        return;
      }
      bindingMailbox(emailForm)
        .then(() => {
          this.$store.dispatch("GetInfo");
        })
        .catch((e) => {
          this.$message.warn(e.msg);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.setting-info-body {
  width: 1240px;
  height: 100%;
  background: #fafafa;
  margin: 0 auto;

  > div {
    padding: 24px;

    .setting-info-content {
      padding-bottom: 40px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 40px;

      &:last-child {
        margin-bottom: 0;
        border-bottom: 0;
      }
    }

    .bind-title {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      > strong {
        line-height: 16px;
        font-size: 15px;
        border-left: 4px solid #1abc9c;
        padding-left: 10px;
        margin-right: 24px;
      }

      > p {
        flex: 1;
        height: 32px;
        background: #edfcf7;
        border: 1px solid #bbf0de;
        border-radius: 2px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        color: #1abc9c;

        > i {
          margin-right: 8px;
        }
      }
    }

    .bind-info {
      display: flex;
      align-items: center;
      padding-left: 10px;

      > p {
        margin-right: 24px;
      }
    }

    .bind-from {
      padding-left: 10px;

      > div {
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        > span {
          width: 70px;
          white-space: nowrap;
        }

        > div {
          width: 400px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
